import classNames from 'classnames'
import { withTranslate } from '@i18n/utils'
import Icon from '@components/Icon'
import CircleLoader from '@components/CircleLoader'
import './textfield.scss'

//TODO Form validation does not seems to work properly, need to be refactored
const Textfield = ({
    label,
    iconLeft,
    iconRight,
    onRightIconClickHandler,
    isLoading,
    status,
    size,
    className,
    initialValue,
    translate: t,
    id,
    ...inputProps
}) => {
    const [value, setValue] = React.useState(initialValue || inputProps.value || '')
    const getIconSize = () => (size === 'small' ? 'xs' : 'sm')

    const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

    const onInputChange = e => {
        const { value: targetValue, type } = e.target

        e.target.setCustomValidity('')

        if (targetValue.length > 0 && inputProps.enterSymbolsValidation && !inputProps.regex.test(targetValue)) {
            inputProps.setShowError && inputProps.setShowError(true)
            e.stopPropagation()
            return e.preventDefault()
        }

        if (targetValue.length > 0 && type === 'email' && !emailRegex.test(targetValue)) {
            getErrorMessage(e)
        }

        inputProps.onChange && inputProps.onChange(e, targetValue)
        setValue(targetValue)
        inputProps.setShowError && inputProps.setShowError(false)
    }

    const classList = classNames('textfield', {
        'is-active': value,
        'is-loading': isLoading,
        [`textfield--${size}`]: size,
        'textfield--icon-left': iconLeft,
        'textfield--icon-right': iconRight,
        'textfield--no-label': !label,
        [`textfield--${status}`]: status,
        [`${className}`]: className,
    })

    const getErrorMessage = event => {
        const errorType = event?.target?.validity
        const inputType = event?.target?.type
        const inputValue = event.target.value

        if (errorType?.valueMissing) {
            return event.target.setCustomValidity(t('input.required.error.message'))
        }

        if (errorType?.patternMismatch) {
            return event.target.setCustomValidity(t('input.patternMismatch.error.message'))
        }

        if (
            inputType === 'email' &&
            (!emailRegex.test(inputValue) || errorType?.typeMismatch || errorType?.customError)
        ) {
            return event.target.setCustomValidity(t('input.email.pattern.mismatch.error.message') + inputValue)
        }

        return event.target?.setCustomValidity('')
    }

    return (
        <div className={classList}>
            {iconLeft && (
                <Icon type={iconLeft} size={getIconSize()} className="textfield__icon textfield__icon--left" />
            )}
            <input
                {...inputProps}
                id={id}
                onInvalid={getErrorMessage}
                value={inputProps.value !== undefined ? inputProps.value : value}
                className="textfield__input"
                onChange={onInputChange}
            />
            <label htmlFor={id} className="textfield__label">
                {label}
            </label>
            {isLoading ? (
                <div className="textfield__loader">
                    <CircleLoader size="small" />
                </div>
            ) : iconRight ? (
                <Icon
                    type={iconRight}
                    size={getIconSize()}
                    className="textfield__icon textfield__icon--right"
                    onClick={onRightIconClickHandler}
                />
            ) : null}
        </div>
    )
}

export default withTranslate(Textfield)
